<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Dashboard" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />

          <div class="card-with-tab mb-3">
            <div class="">
              <ul class="nav nav-pills">
                <li
                  v-for="tab in upperTabs"
                  v-bind:key="tab.link"
                  class="nav-item"
                >
                  <router-link
                    :to="tab.link"
                    :class="
                      `nav-link ${
                        tab.label == 'REKAPITULASI LAPORAN' ? 'active' : ''
                      }`
                    "
                    >{{ tab.label }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <LeftMenuRl active="rl3" />
            </div>
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-8">
                  <PageContentHeader
                    :data="dataRl"
                    :fromUrl="fromUrl || ''"
                    :fromTab="$route.query.fromTab || ''"
                  />
                </div>
              </div>
              <div>
                <b-tabs content-class="mt-3">
                  <b-tab title="RL 3.1" active>
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-0">
                          <div class="col-md-6">
                            <h4 class="mt-2">
                              Formulir RL 3.1 Kegiatan Pelayanan Rawat Inap
                            </h4>
                          </div>
                          <div class="col-md-3">
                            <FormRow
                              :row="filters"
                              @handleChange="(e) => handleChange(e)"
                            />
                          </div>
                          <div class="col-md-1 pl-0">
                            <button
                              class="btn btn-secondary btn-block"
                              @click="apply"
                            >
                              Apply
                            </button>
                          </div>
                          <div class="col-md-2 pl-3">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl31"
                              worksheet="RL-3.1"
                              name="rekapitulasi_laporan_3_1"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div style="height: 720px; width: 100%; overflow: auto">
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl31,
                              rowHeaders: false,
                              colHeaders: false,
                              height: 'auto',
                              width: '100%',
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.2">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-2">
                          <div class="col-md-12">
                            <h4 class="mt-2">
                              Formulir RL 3.2 Kegiatan Pelayanan Rawat Darurat
                            </h4>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-7">
                            <FormRow
                              :row="filtersRl5"
                              @handleChange="(e) => handleChange(e)"
                            />
                          </div>
                          <div class="col-md-2 pl-0">
                            <button
                              class="btn btn-secondary btn-block"
                              @click="apply"
                            >
                              Apply
                            </button>
                          </div>
                          <div class="col-md-3 pl-4">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl32"
                              worksheet="RL-3.2"
                              name="rekapitulasi_laporan_3_2"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <hr class="mt-0" />
                        <div style="height: 720px; width: 100%; overflow: auto">
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl32,
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.3">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.3 Kegiatan Kesehatan Gigi dan Mulut
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl33"
                              worksheet="RL-3.3"
                              name="rekapitulasi_laporan_3_3"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl33,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.4">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.4 Kegiatan Kebidanan
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl34"
                              worksheet="RL-3.4"
                              name="rekapitulasi_laporan_3_4"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl34,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.5">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.5 Kegiatan Perinatologi
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl35"
                              worksheet="RL-3.5"
                              name="rekapitulasi_laporan_3_5"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl35,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.6">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.6 Kegiatan Pembedahan
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl36"
                              worksheet="RL-3.6"
                              name="rekapitulasi_laporan_3_6"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl36,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.7">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.7 Kegiatan Radiologi
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl37"
                              worksheet="RL-3.7"
                              name="rekapitulasi_laporan_3_7"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl37,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.8">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.8 Pemeriksaan Laboratorium
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl38"
                              worksheet="RL-3.8"
                              name="rekapitulasi_laporan_3_8"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl38,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.9">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.9 Pelayanan Rehabilitasi Medik
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl39"
                              worksheet="RL-3.9"
                              name="rekapitulasi_laporan_3_9"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl39,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.10">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.10 Kegiatan Pelayanan Khusus
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl310"
                              worksheet="RL-3.10"
                              name="rekapitulasi_laporan_3_10"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl310,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.11">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.11 Kegiatan Kesehatan Jiwa
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl311"
                              worksheet="RL-3.11"
                              name="rekapitulasi_laporan_3_11"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl311,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">
                              Formulir RL 3.12 Kegiatan Keluarga Berencana
                            </h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl312"
                              worksheet="RL-3.12"
                              name="rekapitulasi_laporan_3_12"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl312,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.13">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-2">
                          <div class="col-md-12">
                            <h4 class="mt-2">
                              Formulir RL 3.13 Pengadaaan Obat, Penulisan &
                              Pelayanan Resep
                            </h4>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-7">
                            <FormRow
                              :row="filtersRl5"
                              @handleChange="(e) => handleChange(e)"
                            />
                          </div>
                          <div class="col-md-2 pl-0">
                            <button
                              class="btn btn-secondary btn-block"
                              @click="apply"
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                        <hr class="mt-0" />
                        <div class="row my-3">
                          <div class="col-md-9">
                            <h4 class="mb-0 mt-2">Pengadaan Obat</h4>
                          </div>
                          <div class="col-md-3 pl-4">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl313a"
                              worksheet="RL-3.13a"
                              name="rekapitulasi_laporan_3_13a"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>

                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl313a"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl313a,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                        <div class="row my-3">
                          <div class="col-md-9">
                            <h4 class="mt-2 mb-0">Pelayanan Resep</h4>
                          </div>
                          <div class="col-md-3 pl-4">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl313b"
                              worksheet="RL-3.13b"
                              name="rekapitulasi_laporan_3_13b"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>

                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl313b"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl313b,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.14">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-2">
                          <div class="col-md-12">
                            <h4 class="mt-2">
                              Formulir RL 3.14 Kegiatan Rujukan
                            </h4>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-7">
                            <FormRow
                              :row="filtersRl5"
                              @handleChange="(e) => handleChange(e)"
                            />
                          </div>
                          <div class="col-md-2 pl-0">
                            <button
                              class="btn btn-secondary btn-block"
                              @click="apply"
                            >
                              Apply
                            </button>
                          </div>
                          <div class="col-md-3 pl-4">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl314"
                              worksheet="RL-3.14"
                              name="rekapitulasi_laporan_3_14"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <hr class="mt-0" />
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl314,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="RL 3.15">
                    <div class="card">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-8">
                            <h4 class="mt-2">Formulir RL 3.15 Cara Bayar</h4>
                          </div>
                          <div class="col-md-4 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl315"
                              worksheet="RL-3.15"
                              name="rekapitulasi_laporan_3_15"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl33"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl315,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import DoughnutChart from "@/components/DoughnutChart.js";
// import BarChart from "@/components/BarChart.js";
import HorizontalBarChart from "@/components/HorizontalBarChart.js";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import LeftMenuRl from "@/components/LeftMenuRl.vue";
import {
  ageInterval,
  getInputDate,
  snakeCaseToCapitalize,
} from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { HotTable } from "@handsontable/vue";
import { registerAllModules } from "handsontable/registry";
import "handsontable/dist/handsontable.full.css";
registerAllModules();

import {
  data,
  dataRl3,
  tabs,
  filtersRl3,
  filtersRl5,
  sort,
  upperTabs,
} from "@/data/Dashboard.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "DashboardRl3",
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      loaded: true,
      data: data,
      dataHot: [
        ["", "Ford", "Volvo", "Toyota", "Honda"],
        ["2016", 10, 11, 12, 13],
        ["2017", 20, 11, 14, 13],
        ["2018", 30, 15, 12, 13],
      ],
      dataRl: dataRl3,
      upperTabs: upperTabs,
      LeftMenuRl: LeftMenuRl,
      filters: filtersRl3,
      filtersRl5: filtersRl5,
      formSet: {
        tahun: new Date().getUTCFullYear(),
        dari: "",
        sampai: "",
      },
      rl31: [],
      rl32: [],
      rl33: [],
      rl34: [],
      rl35: [],
      rl36: [],
      rl37: [],
      rl38: [],
      rl39: [],
      rl310: [],
      rl311: [],
      rl312: [],
      rl313: [],
      rl313a: [],
      rl313b: [],
      rl314: [],
      rl315: [],
      dataRl31: [],
      combinedData: [],
    };
  },
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    LeftMenuRl,
    FormRow,
    HotTable,
  },
  methods: {
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
      //console.log(this.formSet);
      // await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
      // this.apply();
    },
    combineData: async function() {
      this.combinedData = [
        {
          data: [
            ...this.rl31.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.1 Kegiatan Pelayanan Rawat Inap",
        },
        {
          data: [
            ...this.rl32.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.2 Kegiatan Pelayanan Rawat Darurat",
        },
        {
          data: [
            ...this.rl33.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.3 Kegiatan Kesehatan Gigi dan Mulut",
        },
        {
          data: [
            ...this.rl34.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.4 Kegiatan Kebidanan",
        },
        {
          data: [
            ...this.rl35.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.5 Kegiatan Perinatologi",
        },
        {
          data: [
            ...this.rl36.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.6 Kegiatan Pembedahan",
        },
        {
          data: [
            ...this.rl37.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.7 Kegiatan Radiologi",
        },
        {
          data: [
            ...this.rl38.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.8 Pemeriksaan Laboratorium",
        },
        {
          data: [
            ...this.rl39.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.9 Pelayanan Rehabilitasi Medik",
        },
        {
          data: [
            ...this.rl310.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.10 Kegiatan Pelayanan Khusus",
        },
        {
          data: [
            ...this.rl311.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.11 Kegiatan Kesehatan Jiwa",
        },
        {
          data: [
            ...this.rl312.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.12 Kegiatan Keluarga Berencana",
        },
        {
          data: [
            ...this.rl313.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.13 Pengadaaan Obat, Penulisan & Pelayanan Resep",
        },
        {
          data: [
            ...this.rl314.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.14 Kegiatan Rujukan",
        },
        {
          data: [
            ...this.rl315.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 3.15 Cara Bayar",
        },
      ];

      //console.log(this.combinedData);
    },
    displayDataRl31: async function(rl, endpoint, firstColumnLabel) {
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          Object.keys(result.data).forEach(function(key, index) {
            let title = snakeCaseToCapitalize(key);
            if (firstColumnLabel) {
              rl.push({ No: index + 1, [firstColumnLabel]: title });
            } else {
              rl.push({ No: index + 1 });
            }

            let header = {};
            if (index == Object.keys(result.data).length - 1) {
              header = { No: "No" };
              if (firstColumnLabel) {
                header[firstColumnLabel] = firstColumnLabel.toUpperCase();
              }
            }
            if (typeof result.data[key] == "object") {
              Object.keys(result.data[key]).forEach(function(innerKey) {
                let title = snakeCaseToCapitalize(innerKey);
                let content = result.data[key][innerKey];
                rl[rl.length - 1][title] = content;

                if (index == Object.keys(result.data).length - 1) {
                  header[title] = title.toUpperCase();
                }
              });

              if (index == Object.keys(result.data).length - 1) {
                // rl = [header,...rl];
                rl.unshift(header);
                //console.log(rl);
              }
            }
          });
          //console.log(self.formSet);
          //   toDisplayData = rl;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl33: async function(rl, endpoint, firstColumnLabel) {
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          result.data.forEach((item, index) => {
            if (!index) {
              rl.push({ No: "No" });
              Object.keys(item).forEach(function(key) {
                rl[rl.length - 1][key] = snakeCaseToCapitalize(key);
              });
            }
            item["No"] = index + 1;
            if ("total" in item) {
              item["jenis_kegiatan"] = "TOTAL";
              item["jumlah"] = item["total"];
              item["No"] = "";
            }
            rl.push({ ...item });
          });
          //console.log("-----------rl33");
          //console.log(rl);
          //console.log("-----------rl33");
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl34: async function(rl, endpoint, firstColumnLabel) {
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          result.data.forEach((item, index) => {
            if (!index) {
              rl.push({ No: "No" });
              Object.keys(item).forEach(function(key) {
                if (typeof item[key] == "object") {
                  Object.keys(item[key]).forEach(function(innerKey) {
                    rl[rl.length - 1][
                      key + "_" + innerKey
                    ] = snakeCaseToCapitalize(key + " " + innerKey);
                  });
                  delete rl[rl.length - 1][key];
                } else {
                  rl[rl.length - 1][key] = snakeCaseToCapitalize(key);
                }
              });
            }
            item["No"] = index + 1;
            if ("total" in item) {
              item["jenis_kegiatan"] = "TOTAL";
              item["jumlah"] = item["total"];
              item["No"] = "";
            }
            Object.keys(item).forEach(function(key) {
              if (typeof item[key] == "object") {
                Object.keys(item[key]).forEach(function(innerKey) {
                  item[key + "_" + innerKey] = item[key][innerKey];
                });
                delete item[key];
              }
            });
            rl.push({ ...item });
          });
          //console.log("-----------rl33");
          //console.log(rl);
          //console.log("-----------rl33");
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl35: async function(rl, endpoint, firstColumnLabel) {
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          Object.keys(result.data).forEach(function(outerKey, outerIndex) {
            if (outerKey == "total") {
              let item = result.data["total"];
              if (typeof item == "object") {
                item["jenis_kegiatan"] = "TOTAL";
                Object.keys(item).forEach(function(key) {
                  if (typeof item[key] == "object") {
                    Object.keys(item[key]).forEach(function(innerKey) {
                      item[(key + "_" + innerKey).replace(/total_/g, "")] =
                        item[key][innerKey];
                    });
                    delete item[key];
                  } else {
                    item["jumlah"] = result.data["total"];
                  }
                });
              } else {
                item = { jenis_kegiatan: "TOTAL", jumlah: item };
              }

              rl.push({ ...item });
            } else {
              result.data[outerKey].forEach((item, index) => {
                if (!outerIndex && !index) {
                  rl.push({ No: "No" });
                  Object.keys(item).forEach(function(key) {
                    if (typeof item[key] == "object") {
                      Object.keys(item[key]).forEach(function(innerKey) {
                        rl[rl.length - 1][
                          key + "_" + innerKey
                        ] = snakeCaseToCapitalize(key + " " + innerKey);
                      });
                      delete rl[rl.length - 1][key];
                    } else {
                      rl[rl.length - 1][key] = snakeCaseToCapitalize(key);
                    }
                  });
                }
                if (!index) {
                  rl.push({
                    No: outerIndex + 1,
                    jenis_kegiatan: snakeCaseToCapitalize(outerKey),
                  });
                }
                item["No"] = outerIndex + 1 + "." + (index + 1);
                if ("total" in item) {
                  item["jenis_kegiatan"] = "TOTAL";
                  item["jumlah"] = item["total"];
                  item["No"] = "";
                }
                Object.keys(item).forEach(function(key) {
                  if (typeof item[key] == "object") {
                    Object.keys(item[key]).forEach(function(innerKey) {
                      item[key + "_" + innerKey] = item[key][innerKey];
                    });
                    delete item[key];
                  }
                });
                rl.push({ ...item });
              });
              //console.log("-----------rl35");
              //console.log(rl);
              //console.log("-----------rl35");
            }
          });
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl36: async function(rl, endpoint, firstColumnLabel) {
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          result.data.forEach((item, index) => {
            if (!index) {
              rl.push({ No: "No" });
              Object.keys(item).forEach(function(key) {
                rl[rl.length - 1][key] =
                  key == "unit" ? "Spesialisasi" : snakeCaseToCapitalize(key);
              });
            }
            item["No"] = index + 1;
            // if ("total" in item) {
            //   item["jenis_kegiatan"] = "TOTAL";
            //   item["jumlah"] = item["total"];
            //   item["No"] = "";
            // }
            rl.push({ ...item });
          });
          //console.log("-----------rl33");
          //console.log(rl);
          //console.log("-----------rl33");
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl313: async function(rl, endpoint, firstColumnLabel) {
      this.errors = [];

      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);

        if (result.status == "200") {
          Object.keys(result.data).forEach((outerOuterKey, idx) => {
            let len = rl[idx].length;
            for (var i = 0; i < len; i++) {
              rl[idx].pop();
            }
            Object.keys(result.data[outerOuterKey]).forEach(
              (outerKey, index) => {
                let item = {};
                //console.log("outerKey ----------- firstColumnLabel");
                //console.log(outerKey);
                //console.log(firstColumnLabel);
                //console.log("outerKey ----------- firstColumnLabel");

                item[firstColumnLabel] = snakeCaseToCapitalize(outerKey);
                if (!index) {
                  rl[idx].push({
                    No: "No",
                    [firstColumnLabel]: snakeCaseToCapitalize(firstColumnLabel),
                  });
                  Object.keys(result.data[outerOuterKey][outerKey]).forEach(
                    function(key) {
                      rl[idx][rl[idx].length - 1][key] =
                        key == "unit"
                          ? "Spesialisasi"
                          : snakeCaseToCapitalize(key);
                      item[key] = result.data[outerOuterKey][outerKey][key];
                    }
                  );
                } else {
                  Object.keys(result.data[outerOuterKey][outerKey]).forEach(
                    function(key) {
                      item[key] = result.data[outerOuterKey][outerKey][key];
                    }
                  );
                }
                item["No"] = index + 1;
                rl[idx].push({ ...item });
              }
            );
          });
          //console.log("-----------rl33");
          //console.log(rl);
          //console.log("-----------rl33");
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl314: async function(rl, endpoint, firstColumnLabel) {
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          Object.keys(result.data).forEach((outerKey, index) => {
            let item = {};
            //console.log("outerKey ----------- firstColumnLabel");
            //console.log(outerKey);
            //console.log(firstColumnLabel);
            //console.log("outerKey ----------- firstColumnLabel");

            item[firstColumnLabel] = snakeCaseToCapitalize(outerKey);
            if (!index) {
              rl.push({
                No: "No",
                [firstColumnLabel]: snakeCaseToCapitalize(firstColumnLabel),
              });
              Object.keys(result.data[outerKey]).forEach(function(key) {
                rl[rl.length - 1][key] =
                  key == "unit" ? "Spesialisasi" : snakeCaseToCapitalize(key);
                item[key] = result.data[outerKey][key];
              });
            } else {
              Object.keys(result.data[outerKey]).forEach(function(key) {
                item[key] = result.data[outerKey][key];
              });
            }
            item["No"] = index + 1;

            // if ("total" in item) {
            //   item["jenis_kegiatan"] = "TOTAL";
            //   item["jumlah"] = item["total"];
            //   item["No"] = "";
            // }
            rl.push({ ...item });
          });
          //console.log("-----------rl33");
          //console.log(rl);
          //console.log("-----------rl33");
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl38: async function(
      rl,
      endpoint,
      firstColumnLabel,
      combineInnerKeys
    ) {
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      let blacklist = [
        "kode",
        "biaya_dewasa",
        "biaya_anak",
        "petugas_persen",
        "tipe_diskon",
        "diskon",
        "ditanggung",
        "formatted_biaya_dewasa",
        "formatted_biaya_anak",
      ];
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        //console.log(JSON.stringify(result));
        if (result.status == "200") {
          Object.keys(result.data).forEach(function(outerKey, outerIndex) {
            if (outerKey == "total_keseluruhan") {
              rl.push({ nama: "TOTAL", jumlah: result.data[outerKey] });
            } else {
              if (!outerIndex) {
                let item = {};
                Object.keys(result.data[outerKey]).forEach(function(innerKey) {
                  if (typeof result.data[outerKey][innerKey] == "object") {
                    Object.keys(result.data[outerKey][innerKey]).forEach(
                      function(key) {
                        //console.log(innerKey);
                        if (blacklist.indexOf(key) < 0) {
                          item[key] =
                            key == "id"
                              ? "No"
                              : key == "nama"
                              ? "Jenis Kegiatan"
                              : snakeCaseToCapitalize(
                                  (combineInnerKeys ? innerKey + "_" : "") + key
                                );
                        }
                      }
                    );
                  } else {
                    item[innerKey] = snakeCaseToCapitalize(innerKey);
                  }
                });
                rl.push(item);
              }
              let item = {};
              Object.keys(result.data[outerKey]).forEach(function(innerKey) {
                if (typeof result.data[outerKey][innerKey] == "object") {
                  Object.keys(result.data[outerKey][innerKey]).forEach(function(
                    key
                  ) {
                    if (blacklist.indexOf(key) < 0) {
                      item[key] = result.data[outerKey][innerKey][key];
                    }
                  });
                } else {
                  item[innerKey] = result.data[outerKey][innerKey];
                }
              });
              if (
                outerKey == "total" &&
                typeof result.data[outerKey] == "object" &&
                result.data[outerKey]["jenis_kegiatan"] === undefined
              ) {
                //console.log("outer Key == total");
                item["jenis_kegiatan"] = "TOTAL";
              }
              rl.push(item);
            }
          });
          //console.log("-----------rl38");
          //console.log(rl);
          //console.log("-----------rl38");
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    displayData: async function(rl, endpoint) {
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          Object.keys(result.data).forEach(function(key) {
            let content = "";
            if (typeof result.data[key] !== "object") {
              content = result.data[key];
            }
            rl.push({
              title: snakeCaseToCapitalize(key),
              key: key,
              content: content,
            });
            if (typeof result.data[key] === "object") {
              Object.keys(result.data[key]).forEach(function(innerKey) {
                let innerContent = "";
                if (typeof result.data[key][innerKey] !== "object") {
                  innerContent = result.data[key][innerKey];
                }
                rl.push({
                  title: snakeCaseToCapitalize(innerKey),
                  key: innerKey,
                  content: innerContent,
                });
                if (typeof result.data[key][innerKey] === "object") {
                  Object.keys(result.data[key][innerKey]).forEach(function(
                    innerInnerKey
                  ) {
                    let innerInnerContent = "";
                    if (
                      typeof result.data[key][innerKey][innerInnerKey] !==
                      "object"
                    ) {
                      innerInnerContent =
                        result.data[key][innerKey][innerInnerKey];
                    }
                    rl.push({
                      title: snakeCaseToCapitalize(innerInnerKey),
                      key: innerInnerKey,
                      content: innerInnerContent,
                    });
                  });
                }
              });
            }
          });
          //console.log(self.formSet);
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    apply: async function() {
      //   this.rl31 = [];
      await this.displayDataRl31(
        this.rl31,
        `rekapitulasi_laporan_3_1/${this.formSet.tahun}`,
        "Jenis Pelayanan"
      );
      await this.displayDataRl31(
        this.rl32,
        `rekapitulasi_laporan_3_2?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        "Jenis Pelayanan"
      );
      await this.displayDataRl33(this.rl33, `rekapitulasi_laporan_3_3`);
      await this.displayDataRl34(this.rl34, `rekapitulasi_laporan_3_4`);
      await this.displayDataRl35(this.rl35, `rekapitulasi_laporan_3_5`);
      await this.displayDataRl36(this.rl36, `rekapitulasi_laporan_3_6`);
      await this.displayDataRl35(this.rl37, `rekapitulasi_laporan_3_7`);
      await this.displayDataRl38(this.rl38, `rekapitulasi_laporan_3_8`);
      await this.displayDataRl35(this.rl39, `rekapitulasi_laporan_3_9`);
      await this.displayDataRl33(this.rl310, `rekapitulasi_laporan_3_10`);
      await this.displayDataRl33(this.rl311, `rekapitulasi_laporan_3_11`);
      await this.displayDataRl38(
        this.rl312,
        `rekapitulasi_laporan_3_12`,
        null,
        true
      );
      await this.displayDataRl313(
        [this.rl313a, this.rl313b],
        `rekapitulasi_laporan_3_13?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        `golongan_obat`
      );
      await this.displayDataRl314(
        this.rl314,
        `rekapitulasi_laporan_3_14?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        `jenis_spesialisasi`
      );
      await this.displayDataRl31(
        this.rl315,
        `rekapitulasi_laporan_3_15`,
        "Cara Pembayaran"
      );
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      //console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    await this.apply();
    await this.combineData();
  },
};
</script>
